import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './contexts/AppContext';
import { MobileLayout } from './components/MobileLayout';
// Screens
import { SplashScreen } from './screens/SplashScreen';
import { OnboardingScreen } from './screens/OnboardingScreen';
import { SignUpScreen } from './screens/SignUpScreen';
import { OTPScreen } from './screens/OTPScreen';
import { UserTypeScreen } from './screens/UserTypeScreen';
import { LocationSetupScreen } from './screens/LocationSetupScreen';
import { NeedsTodayScreen } from './screens/NeedsTodayScreen';
import { HomeScreen } from './screens/HomeScreen';
import { SearchScreen } from './screens/SearchScreen';
import { ProfessionalProfileScreen } from './screens/ProfessionalProfileScreen';
import { SymptomCheckerScreen } from './screens/SymptomCheckerScreen';
import { BookingScreen } from './screens/BookingScreen';
import { PaymentScreen } from './screens/PaymentScreen';
import { BookingConfirmationScreen } from './screens/BookingConfirmationScreen';
import { ChatScreen } from './screens/ChatScreen';
import { VideoCallScreen } from './screens/VideoCallScreen';
import { VisitSummaryScreen } from './screens/VisitSummaryScreen';
import { EmergencyScreen } from './screens/EmergencyScreen';
import { AppointmentsScreen } from './screens/AppointmentsScreen';
import { PrescriptionScreen } from './screens/PrescriptionScreen';
import { LabBookingScreen } from './screens/LabBookingScreen';
import { FamilyProfilesScreen } from './screens/FamilyProfilesScreen';
import { RecordsTimelineScreen } from './screens/RecordsTimelineScreen';
import { WalletScreen } from './screens/WalletScreen';
import { RatingScreen } from './screens/RatingScreen';
import { ReportScreen } from './screens/ReportScreen';
import { NotificationsScreen } from './screens/NotificationsScreen';
import { ProfileScreen } from './screens/ProfileScreen';
import { ProviderSignUpScreen } from './screens/ProviderSignUpScreen';
import { ProviderDashboardScreen } from './screens/ProviderDashboardScreen';
import { VerificationPendingScreen } from './screens/VerificationPendingScreen';
import { VideoWaitingScreen } from './screens/VideoWaitingScreen';
// New Flow Screens
import { BookDoctorFlow } from './screens/flows/BookDoctorFlow';
import { FindNurseFlow } from './screens/flows/FindNurseFlow';
import { HomeVisitFlow } from './screens/flows/HomeVisitFlow';
import { VideoConsultFlow } from './screens/flows/VideoConsultFlow';
import { LabTestsFlow } from './screens/flows/LabTestsFlow';
import { RefillMedsFlow } from './screens/flows/RefillMedsFlow';
import { FamilyCareFlow } from './screens/flows/FamilyCareFlow';
// Placeholder for screens to be built
const PlaceholderScreen = ({
  title
}: {
  title: string;
}) => <div className="flex flex-col items-center justify-center h-full p-6 text-center" data-id="element-0">
    <h1 className="text-2xl font-bold text-text-main mb-2" data-id="element-1">{title}</h1>
    <p className="text-text-secondary" data-id="element-2">This screen is under construction.</p>
  </div>;
export function App() {
  return <AppProvider data-id="element-3">
      <Router data-id="element-4">
        <MobileLayout data-id="element-5">
          <Routes data-id="element-6">
            {/* Auth & Onboarding */}
            <Route path="/" element={<SplashScreen data-id="element-8" />} data-id="element-7" />
            <Route path="/onboarding" element={<OnboardingScreen data-id="element-10" />} data-id="element-9" />
            <Route path="/signup" element={<SignUpScreen data-id="element-12" />} data-id="element-11" />
            <Route path="/otp" element={<OTPScreen data-id="element-14" />} data-id="element-13" />
            <Route path="/usertype" element={<UserTypeScreen data-id="element-16" />} data-id="element-15" />
            <Route path="/location-setup" element={<LocationSetupScreen data-id="element-18" />} data-id="element-17" />
            <Route path="/needs-today" element={<NeedsTodayScreen data-id="element-20" />} data-id="element-19" />

            {/* Main Tabs */}
            <Route path="/home" element={<HomeScreen data-id="element-22" />} data-id="element-21" />
            <Route path="/explore" element={<SearchScreen data-id="element-24" />} data-id="element-23" />
            <Route path="/appointments" element={<AppointmentsScreen data-id="element-26" />} data-id="element-25" />
            <Route path="/chat" element={<ChatScreen data-id="element-28" />} data-id="element-27" />
            <Route path="/profile" element={<ProfileScreen data-id="element-30" />} data-id="element-29" />

            {/* Quick Action Flows */}
            <Route path="/flow/book-doctor" element={<BookDoctorFlow data-id="element-32" />} data-id="element-31" />
            <Route path="/flow/find-nurse" element={<FindNurseFlow data-id="element-34" />} data-id="element-33" />
            <Route path="/flow/home-visit" element={<HomeVisitFlow data-id="element-36" />} data-id="element-35" />
            <Route path="/flow/video-consult" element={<VideoConsultFlow data-id="element-38" />} data-id="element-37" />
            <Route path="/flow/lab-tests" element={<LabTestsFlow data-id="element-40" />} data-id="element-39" />
            <Route path="/flow/refill-meds" element={<RefillMedsFlow data-id="element-42" />} data-id="element-41" />
            <Route path="/flow/family-care" element={<FamilyCareFlow data-id="element-44" />} data-id="element-43" />

            {/* Flows */}
            <Route path="/profile/:id" element={<ProfessionalProfileScreen data-id="element-46" />} data-id="element-45" />
            <Route path="/symptom-checker" element={<SymptomCheckerScreen data-id="element-48" />} data-id="element-47" />
            <Route path="/family" element={<FamilyProfilesScreen data-id="element-50" />} data-id="element-49" />
            <Route path="/records" element={<RecordsTimelineScreen data-id="element-52" />} data-id="element-51" />
            <Route path="/wallet" element={<WalletScreen data-id="element-54" />} data-id="element-53" />
            <Route path="/notifications" element={<NotificationsScreen data-id="element-56" />} data-id="element-55" />

            {/* Booking Flow */}
            <Route path="/booking/step1" element={<BookingScreen data-id="element-58" />} data-id="element-57" />
            <Route path="/payment" element={<PaymentScreen data-id="element-60" />} data-id="element-59" />
            <Route path="/booking-confirmation" element={<BookingConfirmationScreen data-id="element-62" />} data-id="element-61" />
            <Route path="/lab-booking" element={<LabBookingScreen data-id="element-64" />} data-id="element-63" />

            {/* Active Consultations */}
            <Route path="/chat/active" element={<ChatScreen data-id="element-66" />} data-id="element-65" />
            <Route path="/video-waiting" element={<VideoWaitingScreen data-id="element-68" />} data-id="element-67" />
            <Route path="/video-call" element={<VideoCallScreen data-id="element-70" />} data-id="element-69" />
            <Route path="/visit-summary" element={<VisitSummaryScreen data-id="element-72" />} data-id="element-71" />
            <Route path="/prescription" element={<PrescriptionScreen data-id="element-74" />} data-id="element-73" />
            <Route path="/rating" element={<RatingScreen data-id="element-76" />} data-id="element-75" />
            <Route path="/report" element={<ReportScreen data-id="element-78" />} data-id="element-77" />

            {/* Emergency */}
            <Route path="/emergency" element={<EmergencyScreen data-id="element-80" />} data-id="element-79" />

            {/* Provider Flows */}
            <Route path="/provider/signup" element={<ProviderSignUpScreen data-id="element-82" />} data-id="element-81" />
            <Route path="/provider/dashboard" element={<ProviderDashboardScreen data-id="element-84" />} data-id="element-83" />
            <Route path="/provider/verification" element={<VerificationPendingScreen data-id="element-86" />} data-id="element-85" />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace data-id="element-88" />} data-id="element-87" />
          </Routes>
        </MobileLayout>
      </Router>
    </AppProvider>;
}